var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPro7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Komponente_10_51",
    "data-name": "Komponente 10 \\u2013 51",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.262,
    height: 58,
    viewBox: "0 0 50.262 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_29",
    "data-name": "Layer 29",
    transform: "translate(-6 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46837",
    "data-name": "Pfad 46837",
    d: "M53.362,19.866H49.5V16H47.563v3.866H14.7V16H12.766v3.866H8.9a2.9,2.9,0,0,0-2.9,2.9V24.7a2.9,2.9,0,0,0,2.441,2.853L26.3,46.351V59.5a.967.967,0,0,0,1.4.87L35.429,56.5a.967.967,0,0,0,.535-.87V46.351l17.858-18.8A2.9,2.9,0,0,0,56.262,24.7V22.766a2.9,2.9,0,0,0-2.9-2.9Zm.967,4.833a.967.967,0,0,1-.967.967H49.5V27.6h1.615L34.293,45.3a.967.967,0,0,0-.262.665v9.068l-5.8,2.9V45.964a.967.967,0,0,0-.266-.665L11.151,27.6H47.563V25.666H8.9a.967.967,0,0,1-.967-.967V22.766A.967.967,0,0,1,8.9,21.8H53.362a.967.967,0,0,1,.967.967Z",
    transform: "translate(0 -0.468)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46838",
    "data-name": "Pfad 46838",
    d: "M31.8,17.6A5.8,5.8,0,1,0,26,11.8,5.8,5.8,0,0,0,31.8,17.6Zm0-9.666A3.866,3.866,0,1,1,27.933,11.8,3.866,3.866,0,0,1,31.8,7.933Z",
    transform: "translate(-0.668 -0.134)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46839",
    "data-name": "Pfad 46839",
    d: "M8.967,13.6h9.666a.967.967,0,0,0,.865-1.4L14.665,2.536a1.007,1.007,0,0,0-1.73,0L8.1,12.2a.967.967,0,0,0,.865,1.4ZM13.8,5.129l3.269,6.538H10.53Z",
    transform: "translate(-0.067 -0.001)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46840",
    "data-name": "Pfad 46840",
    d: "M44.967,13.6h9.666a.967.967,0,0,0,.967-.967V2.967A.967.967,0,0,0,54.632,2H44.967A.967.967,0,0,0,44,2.967v9.666A.967.967,0,0,0,44.967,13.6Zm.967-9.666h7.733v7.733H45.933Z",
    transform: "translate(-1.27)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46841",
    "data-name": "Pfad 46841",
    d: "M22,10h1.933v7.733H22Z",
    transform: "translate(-0.535 -0.267)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46842",
    "data-name": "Pfad 46842",
    d: "M40,10h1.933v7.733H40Z",
    transform: "translate(-1.136 -0.267)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46843",
    "data-name": "Pfad 46843",
    d: "M40,2h1.933V5.866H40Z",
    transform: "translate(-1.136)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46844",
    "data-name": "Pfad 46844",
    d: "M22,2h1.933V5.866H22Z",
    transform: "translate(-0.535)",
    fill: "#2ecf96"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro7);
export default __webpack_public_path__ + "static/media/Pro7.17eaf84733a4513d3e56be1affebe67e.svg";
export { ForwardRef as ReactComponent };